import React from 'react';
import { Row, Col, Card, Tab, Tabs, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../lib/routing/frontend';
import Helmet from 'react-helmet';
import Alert from 'react-bootstrap/Alert';
import { isSeniorStaff } from '../../lib/helper/authorisation';
import HospitalForm from '../../components/forms/Hospital/HospitalForm';
import { ManageHospitalContacts } from './components/ManageHospitalContacts';
import { ManageHospitalConsultants } from './components/ManageHospitalConsultants';
import { connect } from 'react-redux';
import { hospitalContactRecordAdd, hospitalContactRecordUpdate, hospitalContactRecordRemove, hospitalSingleFetch } from '../../lib/redux/actions/hospitals';
import { hospitalConsultantUpdate } from '../../lib/redux/actions/hospitalConsultant';

class HospitalSingle extends React.Component {
  addHospitalContact = (newContact) => {
    const { hospital, hospitalContactRecordAdd } = this.props;
    return hospitalContactRecordAdd(hospital.id, {
      ...newContact,
      hospital: hospital['@id'],
    });
  };

  updateHospitalContact = (updatedContact, origContact) => {
    const { hospitalContactRecordUpdate } = this.props;
    return hospitalContactRecordUpdate(updatedContact, updatedContact.id);
  };

  removeHospitalContact = (contactToRemove) => {
    const { hospital, hospitalContactRecordRemove } = this.props;
    return hospitalContactRecordRemove(contactToRemove.id, hospital.id);
  };

  updateHospitalConsultantRelation = async (hospitalConsultantId, data) => {
    const { hospital, hospitalConsultantUpdate, hospitalSingleFetch } = this.props;

    try {
      await hospitalConsultantUpdate(hospitalConsultantId, data);
      // Refresh hospital data to get updated relationship
      await hospitalSingleFetch(hospital.id);
    } catch (error) {
      throw error;
    }
  };

  render() {
    const { hospital, deleteHospital, isDeletingHospital, canDeleteHospital = false } = this.props;
    if (!hospital) {
      return (
        <Card className="mb-4">
          <Card.Body>
            <Alert variant="info">Loading hospital...</Alert>
          </Card.Body>
        </Card>
      );
    }

    return (
      <div>
        <Helmet>
          <title>{hospital.name} - Hospital</title>
        </Helmet>
        <Row>
          <Col>
            <Card className="mb-4">
              <Card.Header className={'card-header--crud'}>
                <div className="d-flex align-items-center">
                  <span className="crud__meta">
                    <Link to={ROUTES.HOSPITALS.ALL.replace('/:page', '')}>&larr; Back to Hospitals</Link>
                  </span>
                </div>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col>
                    <h1 className="crud__body-title">
                      {isSeniorStaff() ? 'Edit' : 'View'} Hospital ({hospital.name})
                    </h1>
                  </Col>
                </Row>
                <hr />
                <Tabs defaultActiveKey="details" variant="pills">
                  <Tab eventKey="details" title={`Hospital Details`}>
                    <div className="crud__section mb-3">
                      <div className="crud__section-icon">
                        <i className="fas fa-hospital" />
                      </div>
                      <Row>
                        <Col sm={12} md={8}>
                          <HospitalForm hospital={hospital} readOnly={!isSeniorStaff()} />

                          {isSeniorStaff() && canDeleteHospital && (
                            <>
                              <hr />
                              {isDeletingHospital && (
                                <Alert variant={'danger'}>Deleting a Hospital will permanently remove it from the system. This action cannot be undone.</Alert>
                              )}
                              <button
                                onClick={() => {
                                  deleteHospital();
                                }}
                                className={`btn btn-danger`}
                                type="button">
                                {isDeletingHospital ? 'This is destructive and irreversible. Click again to confirm...' : `Delete Hospital`}
                              </button>
                            </>
                          )}
                        </Col>
                        <Col>
                          <div className="crud__section mb-3 bg-white">
                            <div className="crud__section-icon">
                              <i className="fas fa-chart-bar" />
                            </div>
                            <h2 className="crud__section-header">Hospital Statistics</h2>
                            <p>This Hospital is related to: </p>
                            <ul>
                              <li>
                                <strong>{hospital?.invoiceCount ?? '0'}</strong> Invoices
                              </li>
                              <li>
                                <strong>{hospital?.invoiceBatchCount ?? '0'}</strong> Invoice Batches
                              </li>
                              <li>
                                <strong>{hospital?.contactRecords?.length || 0}</strong> Contact Records
                              </li>
                              <li>
                                <strong>{hospital?.consultants?.length || 0}</strong> Consultants
                              </li>
                            </ul>
                          </div>
                          {/*{!hospital?.isTreatmentSetting || !(!hospital?.consultants?.length || hospital?.consultants?.length < 1 ) && (*/}
                          <ManageHospitalConsultants hospital={hospital} updateHospitalConsultantRelation={this.updateHospitalConsultantRelation} />
                          {/*)}*/}
                        </Col>
                      </Row>
                    </div>
                  </Tab>

                  <Tab
                    eventKey="contacts"
                    title={
                      <span className="d-inline-flex align-items-center">
                        Contact Records{' '}
                        <Badge variant={'dark'} className={'ml-2'}>
                          {hospital?.contactRecords?.length || 0}
                        </Badge>
                      </span>
                    }>
                    <ManageHospitalContacts
                      hospital={hospital}
                      contacts={hospital?.contactRecords || []}
                      addHospitalContact={this.addHospitalContact}
                      updateHospitalContact={this.updateHospitalContact}
                      removeHospitalContact={this.removeHospitalContact}
                    />
                  </Tab>
                </Tabs>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

// Add Redux connections for hospital contact record and consultant actions
const mapDispatchToProps = {
  hospitalContactRecordAdd,
  hospitalContactRecordUpdate,
  hospitalContactRecordRemove,
  hospitalConsultantUpdate,
  hospitalSingleFetch,
};

export default connect(null, mapDispatchToProps)(HospitalSingle);
